/**
 * Unified Sticky Header Behavior
 * Handles hiding/showing header/menu on scroll for both desktop and mobile screens
 */
class StickyHeader {
    constructor() {
        this.element = null;
        this.lastScrollPos = 0;
        this.isDesktop = false;
        this.isMobile = false;
        this.elementHeight = 0;

        this.init();
    }

    init() {
        this.checkBreakpoint();
        this.bindEvents();
    }

    bindEvents() {
        window.addEventListener('on:breakpoint-change', this.handleBreakpointChange.bind(this));
        window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    handleBreakpointChange() {
        this.checkBreakpoint();
    }

    checkBreakpoint() {
        // Check breakpoints
        this.isDesktop = window.matchMedia('(min-width: 768px)').matches;
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;

        // Set target element based on breakpoint
        if (this.isDesktop) {
            this.element = document.querySelector('main-menu');
        } else if (this.isMobile) {
            this.element = document.querySelector('store-header');
            this.elementHeight = this.element ? this.element.offsetHeight : 0;
        }

        if (!this.isDesktop && !this.isMobile) {
            // Reset visibility if neither desktop nor mobile
            if (this.element) {
                this.element.classList.remove('is-hidden', 'is-sticky');
                this.element.style.transform = '';
            }
        }
    }

    handleScroll() {
        if (!this.element) return;

        const currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;
        const scrollDelta = currentScrollPos - this.lastScrollPos;
        const threshold = this.isMobile ? this.elementHeight : 100;

        // Only apply behavior if we've scrolled past the threshold
        if (currentScrollPos > threshold) {
            if (scrollDelta > 0) {
                // Scrolling down - hide the element
                this.element.classList.add('is-hidden');
                this.element.classList.remove('is-sticky');
                this.adjustFiltersPosition(false);
            } else if (scrollDelta < -10) { // Require minimum scroll up distance to prevent flickering
                // Scrolling up - make element sticky
                this.element.classList.add('is-sticky');
                this.element.classList.remove('is-hidden');
                this.adjustFiltersPosition(true);
            }
        } else {
            // Always show element when near top of page
            this.element.classList.remove('is-hidden', 'is-sticky');
            this.adjustFiltersPosition(false);
        }

        this.lastScrollPos = currentScrollPos;
    }

    adjustFiltersPosition(isSticky) {
        const filtersContainer = document.querySelector('.modern-facet-container');
        if (!filtersContainer) return;

        if (isSticky) {
            // When element is sticky, adjust filters top position to account for element height
            const elementHeight = this.element.offsetHeight || 0;
            filtersContainer.style.top = `${elementHeight}px`;
        } else {
            // Reset to default when element is not sticky
            filtersContainer.style.top = '0px';
        }
    }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new StickyHeader();
});
